<template>
  <div class="bi-layout compair-layout">
    <h1 class="mb-5">Standort Report</h1>
    <vs-tabs v-model="currTab">
      <vs-tab label="Historie"></vs-tab>
      <vs-tab label="Bewerber"></vs-tab>
      <vs-tab label="Bewerbungen auf Stellen"></vs-tab>
      <vs-tab label="Stellen"></vs-tab>
    </vs-tabs>
    <div class="vx-row mt-6">
      <div class="vx-col w-full lg:w-1/2">
        <BiCompareBoxUserGroup
          :type="compareType"
          :dataset-label="compareDatasetLabel"
          :max-y="maxY"
          @max-y-updated="e => onMaxY('a', e)"
        />
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <BiCompareBoxUserGroup
          :type="compareType"
          :dataset-label="compareDatasetLabel"
          :max-y="maxY"
          @max-y-updated="e => onMaxY('b', e)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BiCompareBoxUserGroup from "@/components/bi/BiCompareBoxUserGroup";

export default {
  components: {
    BiCompareBoxUserGroup
  },
  data: () => ({
    maxValues: { a: 0, b: 0 },
    currTab: 0
  }),
  computed: {
    compareType() {
      return ["ACTION", "APPLICANT", "APPLICATION", "VACANCY"][this.currTab];
    },
    compareDatasetLabel() {
      return ["Einträge", "Bewerber", "Bewerbungen", "Stellen"][this.currTab];
    },
    maxY() {
      return Math.max(this.maxValues["a"], this.maxValues["b"]);
    }
  },
  methods: {
    onMaxY(chartIdx, value) {
      this.maxValues[chartIdx] = value;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/components/bi/main";
</style>
